var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CoverArrayInput,{attrs:{"realm":_vm.realm,"hide-shuffle-btn":""},on:{"update:modelValue":_setup.update},model:{value:(_setup.model),callback:function ($$v) {_setup.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }